// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
.sales-by-channel-chart {
  display: flex;
  flex-direction: column;
  gap: 16px;
  min-width: 0;
  /**
   * Recharts places ticks/labels with absolute SVG coordinates and \`text-anchor\` assuming
   * LTR flow; inheriting \`dir="rtl"\` from <html> flips that and clips axis labels. Axis and
   * label sides are mirrored through props instead (see \`rtlChartProps\`). Scoped to the
   * surface so \`.recharts-tooltip-wrapper\` keeps the page direction for its Arabic text.
   */
}
.sales-by-channel-chart .recharts-surface {
  direction: ltr;
}
.sales-by-channel-chart__summary {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 12px 20px;
  /* Align with section title / chart — no extra horizontal inset */
  padding: 14px 0;
  border-radius: 10px;
  background: linear-gradient(135deg, hsl(220, 18%, 98%) 0%, hsl(220, 14%, 96%) 100%);
  border: 1px solid hsl(220, 12%, 90%);
}
.sales-by-channel-chart__summary-item {
  min-width: 0;
}
.sales-by-channel-chart__summary-label {
  display: block;
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  color: hsl(220, 9%, 46%);
  margin-bottom: 4px;
}
.sales-by-channel-chart__summary-value {
  font-size: 18px;
  font-weight: 700;
  color: #0f172a;
  font-variant-numeric: tabular-nums;
  line-height: 1.25;
  word-break: break-word;
}
.sales-by-channel-chart__summary-hint {
  margin-top: 2px;
  font-size: 12px;
  font-weight: 500;
  color: hsl(220, 9%, 40%);
  line-height: 1.35;
}
.sales-by-channel-chart__plot {
  width: 100%;
  height: min(420px, max(280px, 52px * var(--sales-by-channel-rows, 6)));
  min-height: 280px;
  position: relative;
  overflow: visible;
}
.sales-by-channel-chart__empty {
  margin: 0;
  padding: 28px 16px;
  text-align: center;
  font-size: 14px;
  color: hsl(220, 9%, 46%);
  background: hsl(220, 14%, 98%);
  border-radius: 10px;
  border: 1px dashed hsl(220, 12%, 88%);
}

.sales-by-channel-chart--bars {
  gap: 0;
}

.sales-by-channel-chart__bars-plot {
  width: 100%;
  margin: 0;
  padding-top: 22px;
}

.sales-by-channel-chart__bars-list {
  display: flex;
  flex-direction: column;
  gap: 13px;
}

.sales-by-channel-chart__bar-row {
  display: grid;
  grid-template-columns: 86px minmax(0, 1fr) 96px;
  align-items: center;
  column-gap: 16px;
  min-height: 16px;
}

.sales-by-channel-chart__bar-name {
  min-width: 0;
  overflow: hidden;
  color: #1f2937;
  font-size: 13px;
  font-weight: 800;
  line-height: 1.2;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.sales-by-channel-chart__bar-track {
  position: relative;
  width: 100%;
  height: 14px;
  overflow: hidden;
  border-radius: 4px;
  background: #f0f1f4;
}

.sales-by-channel-chart__bar-fill {
  display: block;
  height: 100%;
  border-radius: 4px;
}

.sales-by-channel-chart__bar-value {
  color: #1f2937;
  font-size: 11px;
  font-weight: 800;
  line-height: 1;
  text-align: left;
  font-variant-numeric: tabular-nums;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.sales-by-channel-chart__bars-axis {
  display: grid;
  grid-template-columns: 86px 1fr 64px;
  column-gap: 16px;
  margin-top: 12px;
  color: #a0a9b7;
  font-size: 11px;
  line-height: 1;
}

.sales-by-channel-chart__bars-axis span:first-child {
  grid-column: 2;
  justify-self: start;
}

.sales-by-channel-chart__bars-axis span:nth-child(2) {
  grid-column: 2;
  justify-self: center;
}

.sales-by-channel-chart__bars-axis span:last-child {
  grid-column: 2;
  justify-self: end;
}

.sales-by-channel-chart__tooltip {
  min-width: 200px;
  max-width: 280px;
  padding: 12px 14px;
  border-radius: 10px;
  background: #ffffff;
  border: 1px solid hsl(220, 14%, 88%);
  box-shadow: 0 4px 6px -1px rgba(15, 23, 42, 0.07), 0 10px 24px -4px rgba(15, 23, 42, 0.12);
  pointer-events: none;
}

.sales-by-channel-chart__tooltip-accent {
  position: absolute;
  left: 0;
  top: 8px;
  bottom: 8px;
  width: 3px;
  border-radius: 0 2px 2px 0;
  background: linear-gradient(180deg, #2563eb 0%, #1d4ed8 100%);
}

.sales-by-channel-chart__tooltip-inner {
  position: relative;
  padding-left: 10px;
}

.sales-by-channel-chart__tooltip-rank {
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  color: hsl(220, 9%, 46%);
  margin-bottom: 4px;
}

.sales-by-channel-chart__tooltip-title {
  font-size: 15px;
  font-weight: 700;
  color: #0f172a;
  line-height: 1.3;
  margin-bottom: 10px;
}

.sales-by-channel-chart__tooltip-row {
  display: flex;
  align-items: baseline;
  justify-content: space-between;
  gap: 12px;
  font-size: 13px;
  line-height: 1.45;
  margin-top: 6px;
}

.sales-by-channel-chart__tooltip-row:first-of-type {
  margin-top: 0;
}

.sales-by-channel-chart__tooltip-key {
  color: hsl(220, 9%, 42%);
  font-weight: 500;
  flex-shrink: 0;
}

.sales-by-channel-chart__tooltip-val {
  font-weight: 700;
  color: #1e3a5f;
  text-align: right;
  font-variant-numeric: tabular-nums;
}

@media (max-width: 768px) {
  .sales-by-channel-chart__summary {
    grid-template-columns: 1fr;
  }
}`, "",{"version":3,"sources":["webpack://./src/dashboards/salesProductAnalytics/components/SalesByChannelChart/SalesByChannelChart.scss"],"names":[],"mappings":"AAAA,gBAAgB;AAEhB;EACE,aAAA;EACA,sBAAA;EACA,SAAA;EACA,YAAA;EAEA;;;;;IAAA;AAIF;AAEE;EACE,cAAA;AAAJ;AAGE;EACE,aAAA;EACA,gDAAA;EACA,cAAA;EACA,iEAAA;EACA,eAAA;EACA,mBAAA;EACA,mFAAA;EACA,oCAAA;AADJ;AAIE;EACE,YAAA;AAFJ;AAKE;EACE,cAAA;EACA,eAAA;EACA,gBAAA;EACA,sBAAA;EACA,yBAAA;EACA,wBAAA;EACA,kBAAA;AAHJ;AAME;EACE,eAAA;EACA,gBAAA;EACA,cAAA;EACA,kCAAA;EACA,iBAAA;EACA,sBAAA;AAJJ;AAOE;EACE,eAAA;EACA,eAAA;EACA,gBAAA;EACA,wBAAA;EACA,iBAAA;AALJ;AAQE;EACE,WAAA;EACA,sEAAA;EACA,iBAAA;EACA,kBAAA;EACA,iBAAA;AANJ;AASE;EACE,SAAA;EACA,kBAAA;EACA,kBAAA;EACA,eAAA;EACA,wBAAA;EACA,8BAAA;EACA,mBAAA;EACA,qCAAA;AAPJ;;AAWA;EACE,MAAA;AARF;;AAWA;EACE,WAAA;EACA,SAAA;EACA,iBAAA;AARF;;AAWA;EACE,aAAA;EACA,sBAAA;EACA,SAAA;AARF;;AAWA;EACE,aAAA;EACA,+CAAA;EACA,mBAAA;EACA,gBAAA;EACA,gBAAA;AARF;;AAWA;EACE,YAAA;EACA,gBAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,uBAAA;EACA,mBAAA;AARF;;AAWA;EACE,kBAAA;EACA,WAAA;EACA,YAAA;EACA,gBAAA;EACA,kBAAA;EACA,mBAAA;AARF;;AAWA;EACE,cAAA;EACA,YAAA;EACA,kBAAA;AARF;;AAWA;EACE,cAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;EACA,gBAAA;EACA,kCAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;AARF;;AAWA;EACE,aAAA;EACA,oCAAA;EACA,gBAAA;EACA,gBAAA;EACA,cAAA;EACA,eAAA;EACA,cAAA;AARF;;AAWA;EACE,cAAA;EACA,mBAAA;AARF;;AAWA;EACE,cAAA;EACA,oBAAA;AARF;;AAWA;EACE,cAAA;EACA,iBAAA;AARF;;AAWA;EACE,gBAAA;EACA,gBAAA;EACA,kBAAA;EACA,mBAAA;EACA,mBAAA;EACA,oCAAA;EACA,0FACE;EAEF,oBAAA;AAVF;;AAaA;EACE,kBAAA;EACA,OAAA;EACA,QAAA;EACA,WAAA;EACA,UAAA;EACA,0BAAA;EACA,6DAAA;AAVF;;AAaA;EACE,kBAAA;EACA,kBAAA;AAVF;;AAaA;EACE,eAAA;EACA,gBAAA;EACA,sBAAA;EACA,yBAAA;EACA,wBAAA;EACA,kBAAA;AAVF;;AAaA;EACE,eAAA;EACA,gBAAA;EACA,cAAA;EACA,gBAAA;EACA,mBAAA;AAVF;;AAaA;EACE,aAAA;EACA,qBAAA;EACA,8BAAA;EACA,SAAA;EACA,eAAA;EACA,iBAAA;EACA,eAAA;AAVF;;AAaA;EACE,aAAA;AAVF;;AAaA;EACE,wBAAA;EACA,gBAAA;EACA,cAAA;AAVF;;AAaA;EACE,gBAAA;EACA,cAAA;EACA,iBAAA;EACA,kCAAA;AAVF;;AAaA;EACE;IACE,0BAAA;EAVF;AACF","sourcesContent":["@import \"../../../../styles/variables\";\n\n.sales-by-channel-chart {\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n  min-width: 0;\n\n  /**\n   * Recharts places ticks/labels with absolute SVG coordinates and `text-anchor` assuming\n   * LTR flow; inheriting `dir=\"rtl\"` from <html> flips that and clips axis labels. Axis and\n   * label sides are mirrored through props instead (see `rtlChartProps`). Scoped to the\n   * surface so `.recharts-tooltip-wrapper` keeps the page direction for its Arabic text.\n   */\n  .recharts-surface {\n    direction: ltr;\n  }\n\n  &__summary {\n    display: grid;\n    grid-template-columns: repeat(2, minmax(0, 1fr));\n    gap: 12px 20px;\n    /* Align with section title / chart — no extra horizontal inset */\n    padding: 14px 0;\n    border-radius: 10px;\n    background: linear-gradient(135deg, hsl(220 18% 98%) 0%, hsl(220 14% 96%) 100%);\n    border: 1px solid hsl(220 12% 90%);\n  }\n\n  &__summary-item {\n    min-width: 0;\n  }\n\n  &__summary-label {\n    display: block;\n    font-size: 11px;\n    font-weight: 700;\n    letter-spacing: 0.06em;\n    text-transform: uppercase;\n    color: hsl(220 9% 46%);\n    margin-bottom: 4px;\n  }\n\n  &__summary-value {\n    font-size: 18px;\n    font-weight: 700;\n    color: #0f172a;\n    font-variant-numeric: tabular-nums;\n    line-height: 1.25;\n    word-break: break-word;\n  }\n\n  &__summary-hint {\n    margin-top: 2px;\n    font-size: 12px;\n    font-weight: 500;\n    color: hsl(220 9% 40%);\n    line-height: 1.35;\n  }\n\n  &__plot {\n    width: 100%;\n    height: min(420px, max(280px, 52px * var(--sales-by-channel-rows, 6)));\n    min-height: 280px;\n    position: relative;\n    overflow: visible;\n  }\n\n  &__empty {\n    margin: 0;\n    padding: 28px 16px;\n    text-align: center;\n    font-size: 14px;\n    color: hsl(220 9% 46%);\n    background: hsl(220 14% 98%);\n    border-radius: 10px;\n    border: 1px dashed hsl(220 12% 88%);\n  }\n}\n\n.sales-by-channel-chart--bars {\n  gap: 0;\n}\n\n.sales-by-channel-chart__bars-plot {\n  width: 100%;\n  margin: 0;\n  padding-top: 22px;\n}\n\n.sales-by-channel-chart__bars-list {\n  display: flex;\n  flex-direction: column;\n  gap: 13px;\n}\n\n.sales-by-channel-chart__bar-row {\n  display: grid;\n  grid-template-columns: 86px minmax(0, 1fr) 96px;\n  align-items: center;\n  column-gap: 16px;\n  min-height: 16px;\n}\n\n.sales-by-channel-chart__bar-name {\n  min-width: 0;\n  overflow: hidden;\n  color: #1f2937;\n  font-size: 13px;\n  font-weight: 800;\n  line-height: 1.2;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.sales-by-channel-chart__bar-track {\n  position: relative;\n  width: 100%;\n  height: 14px;\n  overflow: hidden;\n  border-radius: 4px;\n  background: #f0f1f4;\n}\n\n.sales-by-channel-chart__bar-fill {\n  display: block;\n  height: 100%;\n  border-radius: 4px;\n}\n\n.sales-by-channel-chart__bar-value {\n  color: #1f2937;\n  font-size: 11px;\n  font-weight: 800;\n  line-height: 1;\n  text-align: left;\n  font-variant-numeric: tabular-nums;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.sales-by-channel-chart__bars-axis {\n  display: grid;\n  grid-template-columns: 86px 1fr 64px;\n  column-gap: 16px;\n  margin-top: 12px;\n  color: #a0a9b7;\n  font-size: 11px;\n  line-height: 1;\n}\n\n.sales-by-channel-chart__bars-axis span:first-child {\n  grid-column: 2;\n  justify-self: start;\n}\n\n.sales-by-channel-chart__bars-axis span:nth-child(2) {\n  grid-column: 2;\n  justify-self: center;\n}\n\n.sales-by-channel-chart__bars-axis span:last-child {\n  grid-column: 2;\n  justify-self: end;\n}\n\n.sales-by-channel-chart__tooltip {\n  min-width: 200px;\n  max-width: 280px;\n  padding: 12px 14px;\n  border-radius: 10px;\n  background: #ffffff;\n  border: 1px solid hsl(220 14% 88%);\n  box-shadow:\n    0 4px 6px -1px rgba(15, 23, 42, 0.07),\n    0 10px 24px -4px rgba(15, 23, 42, 0.12);\n  pointer-events: none;\n}\n\n.sales-by-channel-chart__tooltip-accent {\n  position: absolute;\n  left: 0;\n  top: 8px;\n  bottom: 8px;\n  width: 3px;\n  border-radius: 0 2px 2px 0;\n  background: linear-gradient(180deg, #2563eb 0%, #1d4ed8 100%);\n}\n\n.sales-by-channel-chart__tooltip-inner {\n  position: relative;\n  padding-left: 10px;\n}\n\n.sales-by-channel-chart__tooltip-rank {\n  font-size: 11px;\n  font-weight: 700;\n  letter-spacing: 0.04em;\n  text-transform: uppercase;\n  color: hsl(220 9% 46%);\n  margin-bottom: 4px;\n}\n\n.sales-by-channel-chart__tooltip-title {\n  font-size: 15px;\n  font-weight: 700;\n  color: #0f172a;\n  line-height: 1.3;\n  margin-bottom: 10px;\n}\n\n.sales-by-channel-chart__tooltip-row {\n  display: flex;\n  align-items: baseline;\n  justify-content: space-between;\n  gap: 12px;\n  font-size: 13px;\n  line-height: 1.45;\n  margin-top: 6px;\n}\n\n.sales-by-channel-chart__tooltip-row:first-of-type {\n  margin-top: 0;\n}\n\n.sales-by-channel-chart__tooltip-key {\n  color: hsl(220 9% 42%);\n  font-weight: 500;\n  flex-shrink: 0;\n}\n\n.sales-by-channel-chart__tooltip-val {\n  font-weight: 700;\n  color: #1e3a5f;\n  text-align: right;\n  font-variant-numeric: tabular-nums;\n}\n\n@media (max-width: 768px) {\n  .sales-by-channel-chart__summary {\n    grid-template-columns: 1fr;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
